import { DateRangePickerViews, type IDateRange, type TDateRangePickerViews } from "../types";

export const getDefaultView = (defaultView: DateRangePickerViews, range: IDateRange, views?: TDateRangePickerViews) => {
  if (views && !range.startDate && !range.endDate) {
    const viewsArray = Object.keys(views) as DateRangePickerViews[];

    if (viewsArray.length === 0 || viewsArray.includes(defaultView)) {
      return defaultView;
    }

    return viewsArray[0];
  }
  if (views) {
    if (range.startDate) {
      const milliseconds = range.startDate.getMilliseconds();
      switch (milliseconds) {
        case 0:
          return views.day ? DateRangePickerViews.DAY : defaultView;
        case 1:
          return views.month ? DateRangePickerViews.MONTH : defaultView;
        case 2:
          return views.year ? DateRangePickerViews.YEAR : defaultView;
        default:
          return defaultView;
      }
    }
    if (range.endDate) {
      const milliseconds = range.endDate.getMilliseconds();
      switch (milliseconds) {
        case 999:
          return views.day ? DateRangePickerViews.DAY : defaultView;
        case 998:
          return views.month ? DateRangePickerViews.MONTH : defaultView;
        case 997:
          return views.year ? DateRangePickerViews.YEAR : defaultView;
        default:
          return defaultView;
      }
    }
  }
  return defaultView;
};
